<template>
  <div class="overlay"></div>
  <!-- <transition name="bottom-sheet-anim"> -->
  <!-- <div class="bottom-sheet" v-if="true"> -->
  <div class="bottom-sheet" :class="identifyClass">
    <div class="close-icon" @click="$router.go(-1)">
      <Vue3Lottie
        animationLink="https://lottie.host/6126e458-afda-4cd5-bce8-31a33be493c4/DyCT6a6Y7U.json"
        :speed="1.5"
        :loop="false"
      />
    </div>
    <h2 class="detailHeading">{{ title }}</h2>
    <ul>
      <li class="menuList menuList-header">
        <span>Name</span>
        <span>Single</span>
        <span>Half</span>
        <span>Full</span>
      </li>
    </ul>
    <slot></slot>
  </div>
  <!-- </transition> -->
</template>

<script>
export default {
  props: ["title"],
  computed: {
    identifyClass() {
      // identifying class for bgImage
      let className;
      if (this.title.toLowerCase().includes("chicken")) className = "chicken";
      else if (this.title.toLowerCase().includes("mutton"))
        className = "mutton";
      else if (this.title.toLowerCase().includes("fish")) className = "fish";
      else if (
        this.title.toLowerCase().includes("sweets") ||
        this.title.toLowerCase().includes("drinks")
      )
        className = "sweets";
      else className = "veg";

      return className;
    },
  },
};
</script>

<style scoped>
.overlay {
  min-height: 100vh;
  width: 100vw;

  position: absolute;
  top: 0%;
  left: 0;
  background-color: rgba(0, 0, 0, 0.62);
}
.bottom-sheet {
  /* height: 100vh; */
  min-height: 90vh;
  background-color: #fff7ed;
  overflow: scroll;
  /* background-color: blue; */
  width: 86%;
  padding: 1.6rem 1rem;
  border-radius: 20px;

  position: absolute;
  top: 1rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
.close-icon {
  /* background-color: blue; */
  height: 3.4rem;
  width: 3.4rem;

  position: absolute;
  right: 1%;
  top: 1%;
  cursor: pointer;
}

.bottom-sheet:before {
  content: " ";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.15;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
}

/* detailHeading styles moved to app.vue */
.chicken.bottom-sheet:before {
  background-image: url("https://www.foodandwine.com/thmb/JMrJBrYh3fxDRgkV24_8dZH_zpQ=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/FAW-recipes-crispy-buttermilk-fried-chicken-hero-04-3a32f9a4a1984ecab79fb28e93d4bc00.jpg");
}
.mutton.bottom-sheet:before {
  background-image: url("https://www.licious.in/blog/wp-content/uploads/2023/02/shutterstock_2205168763.jpg");
}
.fish.bottom-sheet:before {
  background-image: url("https://www.kannammacooks.com/wp-content/uploads/masala-fish-fry-recipe-ayala-meen-Mackerel-fry-8.jpg");
}
.veg.bottom-sheet:before {
  background-image: url("https://www.stylecraze.com/wp-content/uploads/2021/08/15-Best-Indian-Vegetarian-Dishes-In-Hindi.jpg");
}
.sweets.bottom-sheet:before {
  background-image: url("https://foodfornet.com/wp-content/uploads/A-selection-of-desserts-on-a-table-800x534.jpg");
}

::-webkit-scrollbar {
  display: none;
}
/* 
.bottom-sheet-anim-enter-from,
.bottom-sheet-anim-leave-to {
  transform: translateY(-100%);
}
.bottom-sheet-anim-enter-active,
.bottom-sheet-anim-leave-active {
  transition: all 0.5s ease;
}
.bottom-sheet-anim-enter-to,
.bottom-sheet-anim-leave-from {
  transform: translateY(0);
} */
</style>
